import { render, staticRenderFns } from "./new.vue?vue&type=template&id=6a347a99&scoped=true"
import script from "./new.vue?vue&type=script&lang=ts"
export * from "./new.vue?vue&type=script&lang=ts"
import style0 from "./new.vue?vue&type=style&index=0&id=6a347a99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a347a99",
  null
  
)

export default component.exports